import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoiceDeleteLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 15,
	viewBox: "0 0 12 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .8,
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .923828,
			y: 4.61523,
			width: 10.1538,
			height: 10.1538,
			fill: "#A3B8C2",
			fillOpacity: .5
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.38462 0H4.61538L2.76923 1.84615H0V3.69231H12V1.84615H9.23077L7.38462 0Z",
			fill: "#A3B8C2",
			fillOpacity: .5
		})]
	})
});
export default SvgInvoiceDeleteLine;
